import {
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  IconButton,
  Paper,
  Stack,
  Typography,
  useTheme,
} from "@mui/material";
import { useToggle } from "@/shared/base/hooks/useToggle";
import React from "react";
import { MdOutlineClose } from "react-icons/md";

interface Props {
  modalProps: ReturnType<typeof useToggle>;
  title?: string | JSX.Element;
  children: React.ReactNode;
  renderActions?: () => React.ReactNode;
}

export function Modal(props: Props) {
  const { palette } = useTheme();
  const { modalProps, title, children, renderActions } = props;
  const actionItems =
    renderActions && React.isValidElement(renderActions())
      ? renderActions()
      : null;

  return (
    <Dialog
      open={modalProps.open}
      onClose={modalProps.toggle}
      PaperComponent={Paper}
      PaperProps={{
        sx: {
          backgroundColor: palette.background.default,
          backgroundImage: "unset",
          border: `1px solid ${palette.divider}`,
        },
      }}
      style={{
        backdropFilter: "blur(4px)",
      }}
    >
      <DialogTitle>
        <Stack
          direction={"row"}
          justifyContent={"space-between"}
          alignItems={"center"}
        >
          <Box width={"100%"}>
            <Typography variant="h5">{title}</Typography>
          </Box>
          <Box>
            <IconButton size="medium" onClick={modalProps.toggle}>
              <MdOutlineClose />
            </IconButton>
          </Box>
        </Stack>
      </DialogTitle>
      <Divider />
      <DialogContent>{children}</DialogContent>
      {actionItems && (
        <>
          <Divider />
          <DialogActions
            sx={{
              padding: 2,
            }}
          >
            {actionItems}
          </DialogActions>
        </>
      )}
    </Dialog>
  );
}
